import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { TradeInTabKey } from '.';
import { type TradeInDataFragment } from '../../../api/fragments/TradeInData';
import { useCompanyContext } from '../../../components/contexts/CompanyContextManager';
import useFormattedSimpleVersioning from '../../../utilities/useFormattedSimpleVersioning';
// eslint-disable-next-line max-len
import TradeInActivityLogWithComment from '../../shared/ActivityLog/ActivityLogWithComment/TradeInActivityLogWithComment';
import { StyledTabContainer } from '../../shared/ApplicationDetailsPage/generic/FormAction';
import TradeInApplicationTab from './TradeInApplicationTab';

const { TabPane } = Tabs;

type TradeInActionProps = {
    tradeIn: TradeInDataFragment;
};

const TradeInAction = ({ tradeIn }: TradeInActionProps) => {
    const { t } = useTranslation('tradeInDetails');

    const { timeZonesByModuleId } = useCompanyContext();
    const timeZone = timeZonesByModuleId[tradeIn.moduleId];

    const { updated, offset } = useFormattedSimpleVersioning({ versioning: tradeIn.versioning, timeZone });

    return (
        <StyledTabContainer defaultActiveKey={TradeInTabKey.TradeIn}>
            <TabPane key={TradeInTabKey.TradeIn} tab={t('tradeInDetails:tabs.application')}>
                <TradeInApplicationTab offset={offset} updated={updated} />
            </TabPane>
            <TabPane key={TradeInTabKey.ActivityLog} tab={t('tradeInDetails:tabs.activityLog')}>
                <TradeInActivityLogWithComment timezone={timeZone} tradeInId={tradeIn.id} />
            </TabPane>
        </StyledTabContainer>
    );
};

export default TradeInAction;
